import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { dialogStyles } from "../../../theme/dialogStyles";
import { Button, Grid } from "@mui/material";
import LoadingButton from "../../../components/LoadingButton";
import { useRouter } from "next/router";
import { routerPushAndScroll } from "../../../utils/router";
import { ENHANCE_PRIORITIES } from "../../../constants/routes";

interface OwnProps {
  open: boolean;
  setOpen(open: boolean): any;
}
type Props = OwnProps;

const StartPrioritiesModal: React.FC<Props> = ({ open, setOpen }) => {
  const classes = dialogStyles();
  const { t } = useTranslation(["common", "prepFq"]);
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="update-email-dialog-title"
      aria-describedby="update-email-dialog-description"
      keepMounted={false}
    >
      <MuiDialogTitle className={classes.root}>
        <Typography variant="h3">
          {t("prepFq:report.startModal.title")}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <DialogContent style={{ paddingLeft: 16 }}>
        <Typography variant="body1" style={{ marginTop: 16 }}>
          {t("prepFq:report.startModal.description")}
        </Typography>
        <Grid
          spacing={1}
          style={{ marginTop: 24 }}
          container
          justifyContent="space-around"
          alignContent="center"
        >
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={handleClose}
            >
              {t("prepFq:report.buttons.changeGuide")}
            </Button>
          </Grid>
          <Grid item>
            <LoadingButton
              variant="contained"
              color="secondary"
              size="large"
              loading={loading}
              onClick={() => {
                setLoading(true);
                routerPushAndScroll(router, ENHANCE_PRIORITIES);
              }}
            >
              {t("prepFq:report.buttons.pickingPriorities")}
            </LoadingButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default StartPrioritiesModal;
